<template lang="pug">

#unsupported-desktop(v-if="show")

  .qr
    img(src="~assets/qrcode.jpg")
  h1 {{ $t('unsupported') }}


  img.lockup(src="~assets/unsupported/lockup.png")

</template>

<script>
import {mapState} from 'vuex'
import {service as AnalyticsService} from 'src/api/AnalyticsService.js'

export default {
  name: 'unsupported-desktop',
  computed: {
    show () {
      return !this.isMobile
    },
    ...mapState({
      isMobile: state => state.browser.isMobile
    })
  },
  mounted () {
    if (!this.show) return
    AnalyticsService.sendEvent('unsupported', 'desktop')
  }
}
</script>

<style lang="sass" scoped>
@import "src/common.sass"

#unsupported-desktop
  +full()
  +flex-center()
  background-color: $cl-red
  background-image: url('~assets/unsupported/bg.jpg')
  background-size: cover
  background-position: center
  z-index: 2001
  text-align: center
  color: white

.qr
  margin: $ui-padding

  img
    width: 150px

h1
  font-style: italic
  white-space: pre-line
  font-weight: normal
  font-size: 20px

.lockup
  position: absolute
  width: 200px
  bottom: 40px
  left: 40px

</style>



// WEBPACK FOOTER //
// Desktop.vue?312d23fa